import { IUtilService } from './interfaces';
import { injectable } from 'inversify';
import { mobileViewWidth, ipadViewWidth } from '../common/constant';

@injectable()
class UtilService implements IUtilService {
  checkIsMobileView = () => {
    return (window.innerWidth <= mobileViewWidth)
  }

  checkIsIpadView = () => {
    return (window.innerWidth <= ipadViewWidth)
  }
}

export default UtilService